var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 12.4286H11V6.35714C11 3.8375 9.1375 1.75536 6.71429 1.40893V0.714286C6.71429 0.319643 6.39464 0 6 0C5.60536 0 5.28571 0.319643 5.28571 0.714286V1.40893C2.8625 1.75536 1 3.8375 1 6.35714V12.4286H0.571429C0.255357 12.4286 0 12.6839 0 13V13.5714C0 13.65 0.0642857 13.7143 0.142857 13.7143H4C4 14.8179 4.89643 15.7143 6 15.7143C7.10357 15.7143 8 14.8179 8 13.7143H11.8571C11.9357 13.7143 12 13.65 12 13.5714V13C12 12.6839 11.7446 12.4286 11.4286 12.4286ZM6 14.5714C5.52679 14.5714 5.14286 14.1875 5.14286 13.7143H6.85714C6.85714 14.1875 6.47321 14.5714 6 14.5714ZM2.28571 12.4286V6.35714C2.28571 5.36429 2.67143 4.43214 3.37321 3.73036C4.075 3.02857 5.00714 2.64286 6 2.64286C6.99286 2.64286 7.925 3.02857 8.62679 3.73036C9.32857 4.43214 9.71429 5.36429 9.71429 6.35714V12.4286H2.28571Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0242691987cf8574d4bbdc6233aa1a14.svg";
export { ForwardRef as ReactComponent };